import {
  Component,
  Input,
  OnInit,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { locationSurchargeType } from "../../../location/location-surcharge/location-surcharge-type.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface DirectionChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-direction-select",
  templateUrl: "./direction-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class DirectionSelectComponent implements OnInit {
  public readonly directionChange = output<string>();
  @Input() public direction;

  public subscription = new Subscription();
  public directionList: SelectItem[] = [
    { label: "destination", value: locationSurchargeType.destination },
    { label: "origin", value: locationSurchargeType.origin },
    { label: "both", value: locationSurchargeType.both },
  ];

  constructor() {}

  ngOnInit() {
    this.initPlaceholder();
  }

  public initPlaceholder() {
    if (!this.direction) {
      this.direction = "Please select direction";
    }
  }

  public onDirectionChange(event: DirectionChangeEvent) {
    this.directionChange.emit(event.value);
  }
}
